import Vue from "vue";
import { ActionTree } from "vuex";
import axios from "@/axios-config/default";
import { IRootState } from "@/store/types";
import { IProvidersUsersState } from ".";
import { ProvidersUsersMutationsNames } from "./enums";
import { IUuidsPayload } from "@/store/types";
import { IProvidersUser } from "@/models/providers-user";

export const actions: ActionTree<IProvidersUsersState, IRootState> = {
    fetchScopedUsersList({ commit }, uuidSP: string): void {
        axios
            .get(
                Vue.prototype.$environmentService.getServicePath("scopedusers"),
                {
                    params: {
                        serviceProviderUuid: uuidSP,
                    },
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    const providersUserList = response.data.sort(
                        (a: IProvidersUser, b: IProvidersUser) => {
                            var nameA = a.emailAddress!.toUpperCase();
                            var nameB = b.emailAddress!.toUpperCase();
                            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                        }
                    );
                    // mutation to storage scoped user list
                    commit(
                        ProvidersUsersMutationsNames.SetScopedUsersList,
                        providersUserList
                    );
                }
            })
            .catch((error) => {
                // mutation to storage error
                commit(ProvidersUsersMutationsNames.SetScopedUsersError, error);
            });
    },
    fetchScopedCPUsersList({ commit }, ids: IUuidsPayload): void {
        axios
            .get(
                Vue.prototype.$environmentService.getServicePath(
                    "cpscopedusers"
                ),
                {
                    params: {
                        serviceProviderUuid: ids.uuidSP,
                        contentProviderUuid: ids.uuidCP,
                    },
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    const providersUserList = response.data.sort(
                        (a: IProvidersUser, b: IProvidersUser) => {
                            var nameA = a.emailAddress!.toUpperCase();
                            var nameB = b.emailAddress!.toUpperCase();
                            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                        }
                    );
                    // mutation to storage scoped user list
                    commit(
                        ProvidersUsersMutationsNames.SetScopedCPUsersList,
                    providersUserList
                    );
                }
            })
            .catch((error) => {
                // mutation to storage error
                // commit(
                //     // ProvidersUsersMutationsNames.SetScopedCpUsersList,
                //     // error
                // );
            });
    },
    fetchUnscopedUsersList({ commit }): void {
        axios
            .get(
                Vue.prototype.$environmentService.getServicePath(
                    "unscopedusers"
                ),
                {
                    params: {},
                }
            )
            .then((response) => {
                if (response.status === 200) {
                    const providersUserList = response.data.sort(
                        (a: IProvidersUser, b: IProvidersUser) => {
                            var nameA = a.emailAddress!.toUpperCase();
                            var nameB = b.emailAddress!.toUpperCase();
                            return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                        }
                    );
                    // mutation to storage  unscoped user  list
                    commit(
                        ProvidersUsersMutationsNames.SetUnscopedUsersList,
                        providersUserList
                    );
                }
            })
            .catch((error) => {
                // mutation to storage error
                commit(
                    ProvidersUsersMutationsNames.SetUnscopedUsersError,
                    error
                );
            });
    },
    setSelectedProvidersUser(this, { commit }, providersUser: IProvidersUser) {
        commit(ProvidersUsersMutationsNames.SetSelected, providersUser);
    },

    resetProvidersUserState({ commit }): void {
        commit(ProvidersUsersMutationsNames.ResetState);
    },
};
